import { Injectable } from "@angular/core";
import { Market } from "@obg/ngx.core";
import { FeatureFlagService } from "@obg/ngx.global";
import { TelemetryService } from "@obg/ngx.global.evo";

import { RegistrationConfigService } from "./registration.config";
import { RNS_FEATURE_FLAG_KEY } from "./registration.const";
import { RNSFeatureFlag } from "./registration.model";

@Injectable({
	providedIn: "root",
})
export class RegistrationChangeService {
	constructor(
		private registrationConfigService: RegistrationConfigService,
		private telemetryService: TelemetryService,
		private featureFlagService: FeatureFlagService
	) {}

	async isNorthStarVariantActive(currentMarket: Market, currentCountryCode?: string): Promise<boolean> {
		const configEnabled = this.isNorthStarRegistrationEnabled(currentMarket, currentCountryCode);
		const variant = await this.telemetryService.getExperimentVariant("rns", 1000);
		const featureFlag = this.featureFlagService.get<RNSFeatureFlag | undefined>(RNS_FEATURE_FLAG_KEY);

		return configEnabled || featureFlag?.enabled || variant === "1";
	}

	private isNorthStarRegistrationEnabled(currentMarket: Market, currentCountryCode?: string): boolean {
		if (!this.registrationConfigService.getNorthStarRegistrationEnabled()) {
			return false;
		}

		const codes = [currentMarket.languageCode.toUpperCase(), currentCountryCode?.toUpperCase() ?? ""];
		const excludedCountries = this.registrationConfigService.getNorthStarRegistrationExcludedCountries();
		return !codes.some((code) => excludedCountries.includes(code));
	}
}
